import { Box } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(72, 187, 120, 0.4);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(72, 187, 120, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(72, 187, 120, 0);
  }
`;

const NotificationIndicator = ({ top = "-6px", right = "-6px", w = "8px", h = "8px", bg = "green.400", duration = "1.5" }) => {
  return (
    <Box
      position="absolute"
      top={top}
      right={right}
      w={w}
      h={h}
      borderRadius="full"
      bg={bg}
      animation={`${pulse} ${duration}s infinite`}
    />
  );
};

export default NotificationIndicator;
